import React from 'react';
import { FaUniversity, FaTools } from 'react-icons/fa';
import iitImage from '../assets/img/iitboys.jpg';
import pauImage from '../assets/img/pau.jpg';
import iitImage2 from '../assets/img/15.jpeg'; 
import iitImage3 from '../assets/img/iit room.jpeg';
import iitImage4 from '../assets/img/Abt ADF mobile.jpeg';
import adf from '../assets/img/grp.png';
import adf2 from '../assets/img/wavecrest1.jpeg'; 
import adf3 from '../assets/img/20.png';
import adf4 from '../assets/img/grp2.png';
import desktopPic from '../assets/img/6.jpeg';
import mobilePic from '../assets/img/6__.jpeg';
import pic from '../assets/img/6.jpeg';
import Navbar from './NavBar';
import Contact from './Contact';
import { SiGooglescholar } from 'react-icons/si';

const Project = () => {
  return (
    <><Navbar />
      <div>
        {/* Mobile image: visible on small screens only */}
        <img
          src={mobilePic}
          alt="mobile"
          className="w-full h-[60vh] lg:hidden object-cover"
        />

        {/* Desktop image: visible on large screens and above */}
        {/* <img
          src={desktopPic}
          alt="desktop"
          className="w-full h-[540px] hidden lg:block object-cover"
        /> */}
      </div>
    <div name='project' className='w-full min-h-screen bg-white py-5'>
    <div className='hidden lg:flex items-center justify-center bg-[white] h-[120px]'>
        {/* <h1 className='text-5xl font-bold text-[#15381b]'>About Us</h1> */}
      </div>
      <div className='container mx-auto lg:px-16 md:px-16 px-6'>
        <h1 className='text-3xl font-semibold text-center mb-8 mt-5'>Our Current Projects</h1>

        {/* Project: Institute for Industrial Technology (IIT) */}
        <div className='flex flex-col md:flex-row justify-center items-center lg:gap-10 md:gap-10 gap-2 mb-12'>
        <div className='md:w-3/5 md:h-[428px]'>
          <div className='grid grid-cols-2'>
            <img src={iitImage} alt='IIT' className='hidden md:block lg:block w-full h-[214px]' />
            <img src={iitImage2} alt='IIT 2' className='hidden md:block lg:block  w-full h-[214px] mt-4 ml-2' />
            <img src={iitImage3} alt='IIT 3' className='hidden md:block lg:block w-full h-[214px] lg:mt-[-8px]' />
            <img src={iitImage4} alt='IIT 4' className='hidden md:block lg:block  w-full h-[214px] ml-2 mt-2' />
          </div>
        </div>

          <div className='md:w-2/5'>
            <div className='flex text-lg mb-4'>
              <FaTools className='inline-block mr-2 text-[#15381b] text-3xl' />
              <h2 className='text-2xl font-semibold'>Institute for Industrial Technology (IIT)</h2>
            </div>
            <img src={iitImage} alt='IIT' className='md:hidden lg:hidden rounded-lg mb-4 md:mb-0 md:mr-4 w-full lg:h-[220px] h-[250px]' />
            <p className='text-gray-700'>
            Established in 2000 by ADF, the Institute for Industrial Technology (IIT) provides vocational training to economically 
            disadvantaged youth in Nigeria. Through its programs, IIT equips students with essential technical skills crucial for
             success in the manufacturing and allied industries. With a focus on empowering individuals from marginalized backgrounds,
              IIT serves as a catalyst for socioeconomic upliftment and empowerment.
            </p>
            <img src={iitImage2} alt='IIT 2' className='md:hidden lg:hidden  rounded-lg mt-4 md:mt-2 w-full h-[250px]' />
            <p className='text-gray-700 mt-4'>For over 20 years IIT has continued to touch and transform lives of youths from economically marginalized families. 
            Each year we admit a minimum of 48 school leavers on scholarship for about 3 years. We could do more if we have the necessary support. Our target is to integrate 
            these youths from economically marginalized families into the workplace so that they become productive and contribute to the economy. Beneficiaries of the school leavers programme are 
            usually between the age of 16 and 23. This target group tend to embrace lifestyles that may be anti-social if not attended to. By passing through IIT programmes, they become multi-skilled 
            tradesmen easily employable in any engineering industry. In this way, IIT helps to break the cycle of poverty.</p>
            {/* <p className='text-gray-700 mt-4'>To ensure the sustainability of this project, we train other categories and offer technical services to industries. Through this, we raise funds to 
            provide scholarship to the beneficiaries of this project. We also put the effort to get support from well-meaning companies, NGO’s and individuals through donations of funds for student 
            scholarships, equipment, building and maintenance, training machinery, teachers training and development etc. Over the years, several individuals and organisations have contributed a 
            great deal to the success of this project. Those who have supported IIT over the years and till date</p> */}
            <img src={iitImage3} alt='IIT 3' className=' md:hidden lg:hidden rounded-lg mt-4 md:mt-2 w-full  h-[250px]' />
            <p className='text-gray-700 mt-4'>
              <strong>Website:</strong> 
              <a href='https://www.iit.edu.ng' 
                 target="_blank"
                 rel="noopener noreferrer" 
                 className='text-[#15381b] hover:underline'>www.iit.edu.ng</a>
            </p>
          </div>
        </div>

        {/* Project: Pan Atlantic University (PAU) */}
        {/* <div className='flex flex-col md:flex-row justify-center lg:gap-10 md:gap-10 gap-2 mb-16 lg:mb-8 md:mb-0 lg:ml-[-15px] items-center mt-12'>
          <div className='md:w-1/2'>
            <img src={pauImage} alt='PAU' className='rounded-lg lg:mb-4 mb-2  md:mb-0 md:ml-4 w-full h-[300px]' />
          </div>
          <div className='md:w-1/2 '>
            <div className=' flex text-lg mb-4'>
              <FaUniversity className='inline-block mr-2 text-[#15381b] text-3xl' />
              <h2 className='text-2xl font-semibold'>Pan Atlantic University (PAU)</h2>
            </div>
            <p className='text-gray-700'>
            Formerly the Lagos Business School, PAU, backed by ADF, offers academic courses and professional education guided by 
            Christian principles. Dedicated to character development, PAU nurtures responsible public opinion and promotes social welfare. 
            Committed to excellence, PAU shapes future leaders equipped to make a positive impact.
            </p>
            <p className='text-gray-700 mt-4'>
              <strong>Website:</strong> <a href='https://www.pau.edu.ng' className='text-[#15381b] hover:underline'>www.pau.edu.ng</a>
            </p>
          </div>
        </div> */}

           {/* Project: ADF Endowment Fund */}
         {/* Project: ADF Endowment Fund */}
        <div className='flex flex-col md:flex-row justify-center items-center lg:gap-10 md:gap-10 gap-2'>
        <div className='md:w-3/5 md:h-[428px]'>
          <div className='grid grid-cols-2'>
            <img src={adf} alt='ADF' className='hidden md:block lg:block w-full h-[214px]' />
            <img src={adf2} alt='ADF2' className='hidden md:block lg:block w-full h-[214px] mt-4 ml-2' />
            <img src={adf3} alt='ADF3' className='hidden md:block lg:block w-full h-[214px] lg:mt-[-8px]' />
            <img src={adf4} alt='ADF4' className='hidden md:block lg:block w-full h-[214px] ml-2 mt-2' />
          </div>
        </div>
          <div className='md:w-2/5 lg:mt-10'>
            <div className='flex text-lg mb-4'>
              <SiGooglescholar className='inline-block mr-2 text-[#15381b] text-3xl' />
              <h2 className='text-2xl font-semibold'>ADF Endowment Fund</h2>
            </div>
            <img src={adf} alt='ADF' className='md:hidden lg:hidden rounded-lg mb-4 md:mb-0 md:mr-4 w-full h-[250px]' />
            <p className='text-gray-700'>
              The ADF Endowment Fund is a strategic financial initiative established by the African
              Development Foundation (ADF) to ensure the long-term sustainability of its mission of
              empowering youth through values-based technical and vocational education.
            </p>
            <img src={adf2} alt='ADF 2' className='md:hidden lg:hidden rounded-lg mt-4 md:mt-2 w-full  h-[250px]' />
            <p className='text-gray-700 mt-4'>
              Founded on the belief that education is the foundation of economic transformation, ADF
              has been instrumental in supporting institutions like the Institute for Industrial
              Technology (IIT) and other youth development programs. The Endowment Fund is designed
              to provide a reliable and perpetual source of funding for these life-changing initiatives.
            </p>
            <img src={adf3} alt='ADF 3' className='md:hidden lg:hidden rounded-lg mt-4 md:mt-2 w-full  h-[250px]' />
            <p className='text-gray-700 mt-4'>
              <strong>Purpose of the Fund</strong><br />
              The Endowment Fund serves as a financial backbone that allows ADF to:
            </p>
            <ul className='list-disc list-inside text-gray-700 mt-2'>
              <li>Sustain operations and program quality regardless of short-term funding cycles</li>
              <li>Expand access to skills training for underserved communities</li>
              <li>Invest in innovation and future-oriented development models</li>
              <li>Preserve the legacy and vision of ADF for generations to come</li>
            </ul>
            <div className='mt-4'>
            <a 
              href='https://iit.edu.ng/support/make-a-contribution'  
              target="_blank"
              rel="noopener noreferrer"
              className='inline-block mt-8 bg-[#15381b] text-white text-lg py-4 px-8 rounded-lg shadow-md hover:bg-gray-100 hover:text-[#15381b] focus:outline-none'
              >Support Us
            </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Contact />
    </>
  );
};

export default Project;